import { schema } from 'normalizr';

export const emailSchema = new schema.Entity('email');
